import { render, staticRenderFns } from "./MultiSimpleKeyboard.vue?vue&type=template&id=6d9b699e&scoped=true&"
import script from "./MultiSimpleKeyboard.vue?vue&type=script&lang=js&"
export * from "./MultiSimpleKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./MultiSimpleKeyboard.vue?vue&type=style&index=0&id=6d9b699e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b699e",
  null
  
)

export default component.exports